module.exports = __webpack_public_path__ + "img/resume-planner.8f5f2756.png";